/**
 * Redirect delle route storiche /srp… verso /enisa-reports… (la pagina è stata rinominata).
 * Conserva sotto-path, query e hash: /srp/42?x=1#y → /enisa-reports/42?x=1#y.
 */

import { Navigate, useLocation } from 'react-router-dom';
import { legacySrpRedirectTarget } from '../features/srp/routes.js';

export function LegacySrpRedirect() {
  const { pathname, search, hash } = useLocation();
  return <Navigate to={legacySrpRedirectTarget(pathname, search, hash)} replace />;
}
